import { supabase, isConfigured } from './supabase.js'
import { track } from './analytics.js'

// Submit a quick star rating (1–5). No-ops cleanly if the backend isn't connected.
export async function submitRating(rating, path) {
  if (!isConfigured) return { ok: true } // don't block the UI in local/dev
  const r = Math.round(Number(rating))
  if (!(r >= 1 && r <= 5)) return { error: 'Pick 1–5 stars.' }
  const { error } = await supabase.from('feedback').insert({ rating: r, path: path || null })
  if (error) return { error: error.message }
  track('rate_calculator', { rating: r })
  return { ok: true }
}

// Submit written feedback (optionally with a rating + reply email). Emailed to the
// site owner by the send-feedback cron.
export async function submitFeedback({ message, email, rating, path }) {
  const msg = (message || '').trim()
  if (msg.length < 2) return { error: 'Please add a short message.' }
  if (!isConfigured) return { ok: true }
  const row = {
    message: msg.slice(0, 4000),
    email: (email || '').trim().slice(0, 200) || null,
    rating: rating ? Math.round(Number(rating)) : null,
    path: path || null,
  }
  const { error } = await supabase.from('feedback').insert(row)
  if (error) return { error: error.message }
  track('submit_feedback', {})
  return { ok: true }
}
